<template>
  <div class="row">
    <div class="col-sm-6 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">FECHA PRIMER PAGO: </label>
        <span>{{ quotation.firstPaymentDate | date('DD/MM/YYYY') }}</span>
      </div>
      <div>
        <label class="control-label font-weight-bold mr-2">CANTIDAD DE PAGOS: </label>
        <span>{{ quotation.payments }}</span>
      </div>
    </div>

    <div class="col-sm-5 offset-sm-1 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">OBSERVACIONES: </label>
        <span>{{ quotation.comment }}</span>
      </div>
    </div>

    <div v-if="quotation.comment" class="col-sm-12 col-xs-12">
      <div>
        <label class="control-label font-weight-bold mr-2">COTIZACIÓN DOLAR: </label>
        <span>{{ +quotation.dollarQuote | toCurrencyARS }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quotation: {
      type: Object,
      required: true,
    },
  },
};
</script>
